﻿{
  "favoriteBoardmakerSoftware": "favorittprogramvare fra Boardmaker",
  "planDetailsStartTrial": "Start en gratis prøveperiode i dag, med tilgang i 30 dager!",
  "community": {
    "summary": "Benytt deg av ferdiglaget, tilgjengelig utdanningsmateriell delt av foreldre, lærere og terapeuter som deg!  Spar tid ved å søke i og filtrere aktiviteter og maler, legg dem enkelt til i kontoen din, og du er klar til å redigere og bruke dem sammen med din favorittprogramvare fra Boardmaker. Med 60 000 GRATIS utskriftsvennlige og interaktive aktiviteter, og over 500 000 medlemmer – hva venter du på?",
    "topReasons": {
      "header": "De beste grunnene til å registrere seg i myBoardmaker Community",
      "points": [
        "Del flotte aktiviteter du har laget",
        "Bruk kraftfulle søkeverktøy til å finne akkurat det du trenger",
        "Finn profesjonelt lagde aktiviteter laget av Boardmaker Education Team",
        "Søk etter aktiviteter som er tilpasset Common Core-standarder",
        "Bli med i spesifikke interessegrupper"
      ]
    },
    "summaryEnd": "Del og utforsk interaktivt og utskriftsvennlig materiell som fremmer selvstendighet og ferdighetsutvikling hos elevene, og som i tillegg gir adferdsstøtte – alt helt GRATIS.",
    "features": [
      {
        "featureTitle": "Finn",
        "featureDescription": "Oppdag tilpasset pensum, visuelle planer, kommunikasjonstavler, aktiviteter tilpasset utdanningsstandarder, og flere andre støtter utviklet og brukt av foreldre, terapeuter og lærere."
      },
      {
        "featureTitle": "Del",
        "featureDescription": "Last opp aktiviteter du har laget, delta i diskusjoner, opprett offentlige og private delingsgrupper, og mye mer."
      },
      {
        "featureTitle": "Bruk",
        "featureDescription": "Lagre aktivitetene dine på nett, og få tilgang til dem fra hvilken som helst datamaskin."
      },
      {
        "featureTitle": "Skap forbindelser",
        "featureDescription": "Knytt kontakt med andre som lærer bort de samme fagene, eller på samme klassetrinn, utveksle ideer med foreldre som står overfor de samme type utfordringene som deg, og del løsninger som du selv har laget."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 eller senere"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 eller senere"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 eller senere"]
      ],
      "browser": [
        ["Chrome", "v49.0", "gjeldende"],
        ["Firefox", "v38.0", "gjeldende"],
        ["Safari", "v11.0", "gjeldende"],
        ["Edge", "v83.0.478.45", "gjeldende"],
        ["Internet Explorer", "v10.0", "v11.0 eller senere"]
      ]
    }
  },
  "personal": {
    "summary": "Få kraften i Boardmaker inn i hjemmet ditt. Et personlig abonnement på myBoardmaker gir deg muligheten til å ta en aktiv rolle barnets fremgang ved å tilby stabilitet og samsvar mellom hjem, skole og terapi – et alternativ som utvider læringen ut over skoledagen, og til og med ut over skoleåret. Bygg nettverk med andre foreldre i Boardmaker Community for å dele aktiviteter og få nye ideer til mange flere.",
    "topReasons": {
      "header": "De beste grunnene til å velge et personlig abonnement på myBoardmaker",
      "points": [
        "Tilgang til engasjerende og interaktive aktiviteter på alle datamaskiner eller iPad-er",
        "Skriv ut aktiviteter ved behov",
        "Ta en aktiv foreldrerolle i barnets læring hjemme",
        "Ta med dere morsomt og engasjerende materiell uansett hvor dere drar, og opprett eller rediger aktiviteter på hvilken som helst datamaskin"
      ]
    },
    "summaryEnd": "Start en gratis prøveperiode i dag, med full tilgang i 30 dager!",
    "features": [
      {
        "featureTitle": "Opprett og rediger",
        "featureDescription": "Opprett og rediger symboltilpassede aktiviteter, som visuelle planer for planlegging av dagen, individuelle bøker og læringsmateriell, og adferdsstøtte! Mulighetene er uendelige med et bibliotek med over 80 000 symboler å velge mellom – og nye legges til hver andre uke. Trenger du flere? Bruk nettsøk-alternativet for å hente inn alle slags mediafiler til prosjektet ditt."
      },
      {
        "featureTitle": "Skriv ut og spill",
        "featureDescription": "Skriv ut dine egne aktiviteter, eller aktiviteter du finner i Boardmaker Community, rett fra nettleseren for å bruke dem med barnet ditt. Ønsker du å øke engasjementet? Prøv de interaktive malene og aktivitetene våre. Barn og foreldre kan enkelt spille aktiviteter via gratisappen Student Center på nettbrett eller kommunikasjonsenhet."
      },
      {
        "featureTitle": "Lær bort og bygg videre",
        "featureDescription": "Sett fart på barnets lese- og skriveferdigheter med tilgang til de tre brukervennlige pensumprogrammene våre. Begynn med Core First Learning – et verktøy som hjelper barnet med å lære betydningen, bruken og plasseringen av mye brukte kjerneord. Ideelt for personer som bruker kjernebaserte supplerende kommunikasjonssystemer, eller de som lærer å lese! Bruk disse nye ferdighetene til å lese litteratur på klassetrinnivå med Book Bridge, og bygg på videre med kunnskap om verden gjennom utforskning av historie, geografi, samfunn og kultur med Expedition Education."
      },
      {
        "featureTitle": "Finn og del",
        "featureDescription": "Hvorfor finne opp hjulet på nytt? Velg blant 60 000 GRATIS ferdiglagde utskriftsvennlige og interaktive aktiviteter, og 1 100 kategoriserte offentlige grupper i Boardmaker Community – det største delingsfellesskapet av sitt slag i hele verden. Du kan også laste opp aktiviteter du har laget selv til din myBoardmaker Community-konto, og dele dem med foreldre, terapeuter eller elevens støtteteam."
      },
      {
        "featureTitle": "Overvåk og følg opp",
        "featureDescription": "Overvåk og følg barnets fremgang idet de jobber med aktiviteter, for å sørge for suksess og for å finne den mest effektive fremgangsmåten for ditt barn."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 eller senere"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 eller senere"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 eller senere"]
      ],
      "browser": [
        ["Chrome", "v49.0", "gjeldende"],
        ["Firefox", "v38.0", "gjeldende"],
        ["Safari", "v11.0", "gjeldende"],
        ["Edge", "v83.0.478.45", "gjeldende"],
        ["Internet Explorer", "v10.0", "v11.0 eller senere"]
      ]
    }
  },
  "professional": {
    "summary": "Et profesjonelt abonnement på myBoardmaker er det mest komplette systemet for blant annet spesialpedagoger, logopeder, ergoterapeuter og adferdsterapeuter for å finne, lage, organisere og levere tilpassede visuelle støtter, symbolbasert kommunikasjon og terapiaktiviteter som møter behovene til elevene i ditt klasserom eller i din avtalebok.",
    "topReasons": {
      "header": "De beste grunnene til å velge et profesjonelt abonnement på myBoardmaker",
      "points": [
        "Administrer og tildel elevaktiviteter hvor som helst, fra alle datamaskiner",
        "Bruk det utstrakte biblioteket med standardtilpassede prøveaktiviteter, eller lag dine egne",
        "Elevene kan åpne instruksjonsaktiviteter fra hvilken som helst datamaskin eller iPad på skolen eller hjemme",
        "Samle inn data og følg elevenes fremgang mot individuelle elevmål og utdanningsstandarder",
        "Innebygde verktøy hjelper deg med å samarbeide og dele med andre teammedlemmer"
      ]
    },
    "summaryEnd": "Start en gratis prøveperiode i dag, med full tilgang i 30 dager!",
    "features": [
      {
        "featureTitle": "Opprett og rediger",
        "featureDescription": "Opprett og rediger symboltilpassede aktiviteter, som visuelle planer for planlegging av dagen, individuelle bøker og læringsmateriell, og adferdsstøtte! Mulighetene er uendelige med et bibliotek med over 80 000 symboler å velge mellom – og nye legges til hver andre uke. Trenger du flere? Bruk nettsøk-alternativet for å hente inn alle slags mediafiler til prosjektet ditt."
      },
      {
        "featureTitle": "Skriv ut og spill",
        "featureDescription": "Skriv ut dine egne aktiviteter, eller aktiviteter du finner i Boardmaker Community, rett fra nettleseren for å bruke dem med barnet ditt. Ønsker du å øke engasjementet? Prøv de interaktive malene og aktivitetene våre. Barn og foreldre kan enkelt spille aktiviteter via gratisappen Student Center på nettbrett eller kommunikasjonsenhet."
      },
      {
        "featureTitle": "Lær bort og bygg videre",
        "featureDescription": "Hjelp eleven med å ta neste steg i utdanningsreisen sin med tilgang til tre solide, standardtilpassede pensumprogrammer. Boardmaker Instructional Solutions, som kommer inkludert med myBoardmaker-abonnementet ditt, inneholder mer enn 140 steg-for-steg-læreplaner, mer enn 1 500 differensierte og standardtilpassede aktiviteter, 300+ utskriftsvennlige og tilgjengelige bøker, klasseromsverktøy, spørreleker, spill, oppskrifter, formingsaktiviteter og mer!"
      },
      {
        "featureTitle": "Finn og del",
        "featureDescription": "Hvorfor finne opp hjulet på nytt? Velg blant 60 000 GRATIS ferdiglagde utskriftsvennlige og interaktive aktiviteter, og 1 100 kategoriserte offentlige grupper i Boardmaker Community – det største delingsfellesskapet av sitt slag i hele verden. Du kan også laste opp aktiviteter du har laget selv til din myBoardmaker Community-konto, og dele dem med foreldre, terapeuter eller elevens støtteteam."
      },
      {
        "featureTitle": "Overvåk og følg opp",
        "featureDescription": "Overvåk og følg barnets fremgang idet de jobber med aktiviteter, for å sørge for suksess og for å finne den mest effektive fremgangsmåten for ditt barn."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 eller senere"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 eller senere"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 eller senere"]
      ],
      "browser": [
        ["Chrome", "v49.0", "gjeldende"],
        ["Firefox", "v38.0", "gjeldende"],
        ["Safari", "v11.0", "gjeldende"],
        ["Edge", "v83.0.478.45", "gjeldende"],
        ["Internet Explorer", "v10.0", "v11.0 eller senere"]
      ]
    }
  },
  "organization": {
    "summary": "Et organisasjonsabonnement på myBoardmaker støtter ditt tverrfaglige team ved å levere tilpassede aktiviteter, adferdsstøtte og målinger av fremgang mot standarder og mål. \n\nBoardmaker Onlines skybaserte system gir et rammeverk for regelmessighet og samarbeid på tvers av hele organisasjonen, og gjør at personalet kan jobbe fra hvor som helst. I tillegg gir det dem tilgang til et bibliotek med over 60 000 forhåndslagde aktiviteter, tre komplette pensumprogrammer og mer enn 80 000 Picture Communication Symbols for å få fart på undervisningsplanleggingen. Nå kan de ansatte raskt levere utskriftsvennlige og interaktive aktiviteter for å utvide læring og terapi for sine elever og brukere ved hjelp av Boardmaker Student Center – alt med ett knappetrykk!\n\nSe personalbruk og øk effektiviteten på tvers av hele organisasjonen med sentral administrering av kontoer og data, i tillegg til avanserte delings- og samarbeidsverktøy.",
    "topReasons": {
      "header": "De beste grunnene til å velge et organisasjonsabonnement på myBoardmaker",
      "points": [
        "Det skybaserte systemet gir regelmessighet og samarbeid på tvers av hele organisasjonen, og gjør at personalet kan jobbe fra hvor som helst",
        "Et omfattende bibliotek med prøveaktiviteter som allerede er tilpasset College and Career Readiness-standarder og dine delstatsspesifikke standarder",
        "Elevene kan åpne instruksjonsaktiviteter hvor som helst, fra hvilken som helst datamaskin",
        "Aktiviteter kan tilknyttes individuelle elevmål for å demonstrere fremgang for elevene",
        "Umiddelbar tilgang til fremgangsdata om elever, og personalbruk, alt i ett system"
      ]
    },
    "summaryEnd": "",
    "features": [
      {
        "featureTitle": "Opprett og rediger",
        "featureDescription": "Opprett og rediger symboltilpassede aktiviteter, som visuelle planer for planlegging av dagen, individuelle bøker og læringsmateriell, og adferdsstøtte! Mulighetene er uendelige med et bibliotek med over 80 000 symboler å velge mellom – og nye legges til hver andre uke. Trenger du flere? Bruk nettsøk-alternativet for å hente inn alle slags mediafiler til prosjektet ditt."
      },
      {
        "featureTitle": "Skriv ut og spill",
        "featureDescription": "Skriv ut dine egne aktiviteter, eller aktiviteter du finner i Boardmaker Community, rett fra nettleseren. Ønsker du å øke engasjementet? Oppmuntre teamet ditt til å prøve de interaktive malene og aktivitetene våre. Elevene kan enkelt spille aktiviteter via den fullt tilgjengelige gratisappen Student Center – uten behov for internettilkobling."
      },
      {
        "featureTitle": "Lær bort og bygg videre",
        "featureDescription": "Gi de ansatte tilgang til tre solide, standardtilpassede pensumprogrammer, alt inkludert i ditt organisasjonsabonnement på myBoardmaker. Boardmaker Instructional Solutions inneholder mer enn 140 steg-for-steg-læreplaner, mer enn 1 500 differensierte og standardtilpassede aktiviteter, 300+ utskriftsvennlige og tilgjengelige bøker, klasseromsverktøy, spørreleker, spill, oppskrifter, formingsaktiviteter og mer!"
      },
      {
        "featureTitle": "Tildel og følg",
        "featureDescription": "Med en organisasjonskonto på myBoardmaker kan de ansatte tildele skreddersydde og nivåtilpassede aktiviteter til et ubegrenset antall elever for å følge elevenes individuelle fremgang mot individuelle elevmål og delstats- og lokale standarder. De kan deretter bruke verktøyet Fremgangsovervåking for å raskt sjekke elevens prestasjoner, og enkelt rapportere om fremgang og suksess. Tildelte aktiviteter som fullføres hjemme blir også sporet, slik at de effektivt kan administrere lekser og samarbeide med barnets familie for å utvide læringen til utenfor klasserommet."
      },
      {
        "featureTitle": "Finn og del",
        "featureDescription": "Hvorfor finne opp hjulet på nytt? Velg blant 60 000 GRATIS ferdiglagde utskriftsvennlige og interaktive aktiviteter, og 1 100 kategoriserte offentlige grupper i Boardmaker Community – det største delingsfellesskapet av sitt slag i hele verden. Du kan også laste opp aktiviteter du har laget selv til din myBoardmaker Community-konto, og dele dem med foreldre, terapeuter eller elevens støtteteam."
      }
    ],
    "advantages": [
      {
        "advantageTitle": "Kostnadsbesparelser",
        "advantagePoints": [
          "Eksklusive tilpassede organisasjonspakker for 5+ kontoer",
          "Skybaserte tjenester gjør det enkelt å overføre lisenser ved personalutskiftninger",
          "Volumpriser",
          "Bunter med flere produkter",
          "Spar år etter år"
        ]
      },
      {
        "advantageTitle": "Suksess for alle",
        "advantagePoints": [
          "Forskningsbaserte og ferdiglagde aktiviteter sørger for positive, målbare resultater",
          "Tilpassede læringsmateriell og aktiviteter, som følger prinsippene for Universelt design for læring, gjør læringsmål oppnåelige for individer med varierte evner",
          "Tilpassede pensum gir lik tilgang for alle",
          "Ressurser er tilgjengelige for å sammenfatte ekspertanbefalinger og beste praksis, slik at du får mest mulig ut av løsningene dine"
        ]
      },
      {
        "advantageTitle": "Støtter standarder og krav",
        "advantagePoints": [
          "Løsninger utformet spesielt for å lære bort og måle fremgang mot College and Career Readiness-standarder",
          "Et bredt utvalg av løsninger som støtter Universelt design for læring, Every Child Succeeds og kravene i Individuals with Disabilities Education Act",
          "spor og rapporter om fremgang mot individuelle elevmål automatisk via datakontrollpanaler"
        ]
      },
      {
        "advantageTitle": "Enkel organisasjonsintegrering",
        "advantagePoints": [
          "Gjør at administratorer kan rulle ut og levere kontoer på sekunder",
          "Fleksible og skalerbare alternativer for organisasjonsintegrering",
          "Alle skybaserte løsninger hostes ved et høysikkerhets-datasenter på nivå 1.",
          "Gratis automatiske, skybaserte oppdateringer med nye og spennende funksjoner og ressurser"
        ]
      }
    ],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 eller senere"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 eller senere"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 eller senere"]
      ],
      "browser": [
        ["Chrome", "v49.0", "gjeldende"],
        ["Firefox", "v38.0", "gjeldende"],
        ["Safari", "v11.0", "gjeldende"],
        ["Edge", "v83.0.478.45", "gjeldende"],
        ["Internet Explorer", "v10.0", "v11.0 eller senere"]
      ]
    }
  },
  "boardmakerLicense": {
    "summary": "Neste generasjon Boardmaker-programvare har ankommet!  Boardmaker 7 tar de beste funksjonene fra alle tidligere versjoner, og pakker dem inn i én flerspråklig app på flere plattformer.  Boardmaker 7 har et finjustert brukergrensesnitt som plasserer verktøyene du trenger der du trenger dem.  Den inkluderer de nyeste PCS-symbolene, men den er også bakoverkompatibel med alle de gamle tavlene og aktivitetene dine. Denne nye programvaren gjør at du kan skape og levere tilpasset pensum og kommunikasjonsstøtte raskere enn noensinne.",
    "topReasons": {
      "header": "De beste grunnene til å kjøpe Boardmaker 7-programvaren",
      "points": [
        "Rediger, skriv ut og spill alle de gamle Boardmaker-filene dine",
        "Intuitivt og moderne brukergrensesnitt med innebygde hint og opplæringsmateriell",
        "Fantastiske maler som raskt og enkelt kan tilpasses",
        "Finn symboler og bilder i en fei"
      ]
    },
    "summaryEnd": "Last ned din 30-dagers prøveperiode i dag!",
    "features": [
      {
        "featureTitle": "Åpner alt du har laget",
        "featureDescription": "Ikke kast bort alle årene med hardt arbeid … med programvaren Boardmaker 7 kan du åpne alle filer laget med Boardmaker v5, Boardmaker v6 eller Boardmaker Studio.  Konverteringen er rask og nøyaktig, så selv komplekse interaktive aktiviteter kommer til å fungere og se ut akkurat som originalen."
      },
      {
        "featureTitle": "Lett, lett, lett",
        "featureDescription": "Brukerne har talt!  Boardmaker 7-programvarens grensesnitt, som er basert på utstrakt brukertesting med personer akkurat som deg, er moderne, innbydende og intuitivt.  De innebygde hintene og opplæringsmateriellet gir deg tryggheten til å utforske og utvide ferdighetene dine, og aller viktigst, til å støtte elevene dine."
      },
      {
        "featureTitle": "Rask / sparer tid",
        "featureDescription": "Med redesignede maler for både utskriftsvennlige og interaktive aktiviteter kommer du til å bli imponert over bredden og dybden i det du kan få til på bare noen minutter.  Du blir ferdig med den timeplanen eller den sosiale fortellingen på null komma niks, og du får mer tid til elevene dine.  Boardmaker gjør det også enkelt å tilpasse det du har laget, slik at du få den ideelle kombinasjonen av hurtighet og fleksibilitet."
      },
      {
        "featureTitle": "Suverent symbolsøk",
        "featureDescription": "Vi er symboler. Boardmaker 7 kan skryte av et forbedret symbolsøk og en intuitiv måte å bla gjennom symboler etter kategori på … men det er bare begynnelsen.  Du kan søke etter deler av ord, ord som rimer, individuelle fonemer og konsonant/vokal-mønstre. Dette er det mest kraftfulle søkeverktøyet som finnes!  Og bare sånn i tilfelle du ikke finner det riktige symbolet: du kan raskt og enkelt legge til bilder med det innebygde nettsøket eller med kameraverktøyene."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "10", "Windows 10 eller senere"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 eller senere"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 eller senere"]
      ]
    }
  },
  "studio": {
    "requirements": {
      "operatingSystem": [["Windows OS", "7", "Windows 10"]]
    }
  },
  "scmp": {
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "7", "Windows 10"],
        ["iOS", "6.0", "IOS 6.0 eller senere"],
        ["Android", "Tobii Dynavox T-Series-enheter", ""]
      ],
      "eyeTracker": [
        [
          "PCEye Mini,",
          "PCEye Explore,",
          "PCEye Go,",
          "EyeMobile,",
          "I-12,",
          "I–15"
        ]
      ]
    }
  }
}
